"use client";

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { BarChart3, MessageSquare, Home, LogOut } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

const navigation = [
  { name: 'Дэшборд', href: '/dashboard', icon: Home },
  { name: 'Чаты', href: '/chats', icon: MessageSquare },
];

export default function Navigation() {
  const pathname = usePathname();
  const { user, logout } = useAuth();

  // Не показываем навигацию на странице логина
  if (pathname === '/') {
    return null;
  }

  return (
    <nav className="bg-white/80 dark:bg-zinc-900/80 backdrop-blur-sm border-b border-pink-200 dark:border-pink-800 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <div className="flex-shrink-0 flex items-center">
              <BarChart3 className="h-8 w-8 text-pink-500" />
              <span className="ml-2 text-xl font-semibold text-gray-900 dark:text-white">
                безтендера
              </span>
            </div>
            <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
              {navigation.map((item) => {
                const isActive = pathname === item.href;
                return (
                  <Link
                    key={item.name}
                    href={item.href}
                    className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-colors ${
                      isActive
                        ? 'border-pink-500 text-pink-600 dark:text-pink-400'
                        : 'border-transparent text-gray-500 hover:border-pink-300 hover:text-pink-600 dark:text-gray-400 dark:hover:text-pink-400'
                    }`}
                  >
                    <item.icon className="w-4 h-4 mr-2" />
                    {item.name}
                  </Link>
                );
              })}
            </div>
          </div>
          
          {/* Кнопка выхода */}
          <div className="flex items-center">
            {user && (
              <div className="flex items-center gap-4">
                <span className="text-sm text-gray-600 dark:text-gray-400">
                  {user.first_name} {user.second_name || ''}
                </span>
                <button
                  onClick={logout}
                  className="flex items-center gap-2 px-3 py-2 text-sm text-gray-600 hover:text-red-600 dark:text-gray-400 dark:hover:text-red-400 transition-colors"
                >
                  <LogOut className="w-4 h-4" />
                  Выйти
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div className="sm:hidden">
        <div className="pt-2 pb-3 space-y-1">
          {navigation.map((item) => {
            const isActive = pathname === item.href;
            return (
              <Link
                key={item.name}
                href={item.href}
                className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium transition-colors ${
                  isActive
                    ? 'bg-pink-50 border-pink-500 text-pink-700 dark:bg-pink-900/20 dark:text-pink-400'
                    : 'border-transparent text-gray-500 hover:bg-pink-50 hover:border-pink-300 hover:text-pink-600 dark:text-gray-400 dark:hover:bg-pink-900/10 dark:hover:text-pink-400'
                }`}
              >
                <div className="flex items-center">
                  <item.icon className="w-4 h-4 mr-3" />
                  {item.name}
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
